export const elapsedTimeKeys = {
  all: ['elapsed-time'] as const,
  byTask: (taskId: string | number) =>
    [...elapsedTimeKeys.all, 'task', String(taskId)] as const,
};
